import { service } from '@/utils/request'
import constv from '@/config/constv'

class menu {
  static getList (params) { return service.get(constv.AUTH_URL + '/admin/auth_rule/getRuleList', { params }) }
  static add (params) { return service.post(constv.AUTH_URL + '/admin/auth_rule/addRule', params) }
  static delete (params) { return service.get(constv.AUTH_URL + '/admin/auth_rule/delRule', { params }) }
  static edit (params) { return service.post(constv.AUTH_URL + '/admin/auth_rule/editRule', params) }
  static detail (params) { return service.get(constv.AUTH_URL + '/admin/auth_rule/editRule', { params }) }
}

export default menu
